const deleteUrl = {
	deleteEnquiry: '/enquiry',
	deleteEnquiryItem: '/enquiry/enquiry-item',
	deleteOrder: '/order',
	deleteAuction: '/auction',
	deleteAuctionOrder: '/order',
	deleteLedgerByDocumentId: '/ledger/deleteLedgerByDocumentId',
	deleteBillInvoice: '/invoice',
	deleteOrderDocument: '/files/deleteDocument',
	deleteContent: '/content',
	deleteCommodity: '/commodity',
	deleteFactoryInvoice: '/factory/deleteFabricationInvoice',
	deleteUser: '/organisation/deleteUser',
	deleteUnregisteredUser: 'user/deleteUnregisteredUser',
	deleteEnquiryPhoto: '/enquiryPhoto',
	deleteUserWithOrg: '/extra/deleteUserWithOrg',
	deleteAdmin: '/user/deleteAdmin',
	deleteOrganisation: '/organisation/deleteOrganisation',
	deleteLead: '/lead',
	deleteTaskReminder: '/lead/deleteTaskReminder',
	deleteMeetingRemarks: '/lead/deleteMeetingRemarks',
	deleteGlossary: '/glossary',
	deleteAddressV2: '/organisation/v2/deleteAddress',
	deleteDispatchPlanInvoice: '/dispatchPlan/deleteDispatchInvoice',
	deleteSpoItem: '/supplierOrder/item',
}

export default deleteUrl
